import { render, staticRenderFns } from "./transferencias.vue?vue&type=template&id=3ddbb141"
import script from "./transferencias.vue?vue&type=script&lang=js"
export * from "./transferencias.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports